import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import { AppBar, Toolbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import './KIKD.css'
const KIKD = () => {
	let history = useHistory();
	const useStyles = makeStyles((theme) => ({
		appbar: {
			background: "rgba(75,178,115,0.9)",
		},
		wrapper: {
			width: "85%",
			margin: "0 auto",
			display: "flex",
			justifyContent: "space-between",
		},
	}));
	const classes = useStyles();
		useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	const [showki,setShowki] = useState(true);
	const [showkd,setShowkd] = useState(false);

	const handleKI = () =>{
		setShowki(true);
		setShowkd(false);
	}
	const handleKD = () =>{
		setShowki(false);
		setShowkd(true);
	}
	const [ukuranFont, setUkuranFont] = useState(15);
	return (
		<div>
			<AppBar className={classes.appbar}>
				<Toolbar className={classes.wrapper}>
					<h4>Program Linear</h4>
				</Toolbar>
			</AppBar>
			<div className="container mt-5" >
			<div className="d-flex justify-content-center" style={{marginTop:"5rem"}}>
				<button 
				className={showki?"ki-active":"ki"} 
				 onClick={handleKI}><h5>KI</h5></button> 
				<button className={showkd?"kd-active":"kd"}  onClick={handleKD}><h5>KD</h5></button>
			</div>
		
			<div className="d-flex justify-content-end">
				<p><i>Ukuran Teks</i></p>
			</div>
			<div className="d-flex justify-content-end ">
				<button className="btnplus" onClick={()=>setUkuranFont(ukuranFont + 1)}><h4>+</h4></button>
				<button className="btnplus" onClick={()=>setUkuranFont(ukuranFont - 1)}><h4>-</h4></button>
			</div>

				{showki?
				<>
				<div className="d-flex justify-content-center mt-3">
					<div className="card border-success shadow  bg-body rounded ">
						<div
							style={{ color: "white" }}
							className="card-header bg-success text-center"
						>
							<h4>KI </h4>
						</div>
						<div className="card-body text-secondary">
							<div className="card-tittle">
								<p style={{ color: "black", lineHeight:'35px', fontSize:`${ukuranFont}px` }}>
									<strong>KI-1 dan KI-2 : </strong>Menghayati dan mengamalkan
									ajaran agama yang dianutnya. Menghayati dan mengamalkan
									perilaku jujur, disiplin, santun, peduli (gotong royong,
									kerjasama, toleran, damai), bertanggung jawab, responsif, dan
									pro-aktif dalam berinteraksi secara efektif sesuai dengan
									perkembangan anak di lingkungan, keluarga, sekolah, masyarakat
									dan lingkungan alam sekitar, bangsa, negara, kawasan regional,
									dan kawasan internasional”.
								</p>

								<p style={{ color: "black" , lineHeight:'35px', fontSize:`${ukuranFont}px`}}>
									<strong>KI 3:</strong> Memahami, menerapkan, dan menganalisis
									pengetahuan faktual, konseptual, prosedural, dan metakognitif
									berdasarkan rasa ingin tahunya tentang ilmu pengetahuan,
									teknologi, seni, budaya, dan humaniora dengan wawasan
									kemanusiaan, kebangsaan, kenegaraan, dan peradaban terkait
									penyebab fenomena dan kejadian, serta menerapkan pengetahuan
									prosedural pada bidang kajian yang spesifik sesuai dengan
									bakat dan minatnya untuk memecahkan masalah
								</p>

								<p style={{ color: "black", lineHeight:'35px' , fontSize:`${ukuranFont}px`}}>
									<strong>KI 4:</strong> Mengolah, menalar, dan menyaji dalam
									ranah konkret dan ranah abstrak terkait dengan pengembangan
									dari yang dipelajarinya di sekolah secara mandiri, bertindak
									secara efektif dan kreatif, serta mampu menggunakan metode
									sesuai kaidah keilmuan
								</p>
							</div>
						</div>
					</div>
				</div>
				</>
				:null}
				{showkd?
				<>
					<div className="card border-success shadow  bg-body rounded mt-3">
						<div
							style={{ color: "white" }}
							className="card-header bg-success text-center"
						>
							<h4>KD</h4>
						</div>
						<div className="card-body text-secondary">
							<div className="card-tittle">
								<p style={{ color: "black", lineHeight:'35px' , fontSize:`${ukuranFont}px`}}>
									3.2 Menjelaskan program linear dua variabel dan metode
									penyelesaiannya dengan menggunakan masalah kontekstual{" "}
								</p>

								<p style={{ color: "black", lineHeight:'35px' , fontSize:`${ukuranFont}px`}}>
									4.2 Menyelesaikan masalah kontekstual yang berkaitan dengan
									program linear dua variabel
								</p>
							</div>
						</div>
					</div>				
				</>
				:null}	
			
				<div className="d-flex justify-content-center mt-2 mb-4">			
						<button onClick={() => history.goBack()} className="btn btn-outline-success">Kembali</button>
				</div>
			</div>
		</div>
	);
};

export default KIKD;
